// extracted by mini-css-extract-plugin
export default {"result":"kql6WsBI6xN3hQFumXuk","circle":"fJg9qfy7MyNXSJG7l2yf","description":"DMQZsOmt5EIyP2qZeeaI"};